<template>
  <div class="mixer-side">
    <div class="side-header">
      <p class="mb-0" v-translate>Side orders / mixers</p>
    </div>
    <div class="side-body">
      <div class="grid-mixer">
        <div v-for="mixer in getLastItemMixers"
          :key="mixer.id"
          :style="{'background': mixer.color}"
          class="grid-mixer-item"
          @click="addMixer(mixer)"
        >
          {{ mixer.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import {
  SET_MESSAGE_MODAL
} from '@/store/mutation-types';
export default {
  name: 'MixerSide',
  computed: {
    ...mapGetters(['getLastItemMixers']),
  },
  methods: {
    addMixer(mixer) {
      const result = this.$store.getters.addMixer(mixer);
      if(result.maximum) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Maximum mixer reached') + ' (' + result.maximum + ')');
      }
    }
  }
};
</script>
